<!-- Header: Popper-positioned, appended to body, opens down-left.
     Sidebar: display="static" (no Popper; ng-bootstrap 12 disables Popper's
     overflow protection, so near the left edge the panel ran off screen) —
     the panel is placed by CSS just below the bell, opening to the right. -->
<div ngbDropdown [container]="variant === 'sidebar' ? null : 'body'" [display]="variant === 'sidebar' ? 'static' : 'dynamic'"
  placement="bottom-end" autoClose="outside" (openChange)="onOpenChange($event)" class="d-inline-flex position-relative">
  <button type="button" ngbDropdownToggle class="notification-bell__toggle btn btn-icon position-relative"
    [ngClass]="variant === 'header' ? 'btn-color-white bg-hover-white bg-hover-opacity-10 w-35px h-35px h-md-40px w-md-40px me-5' : 'btn-color-gray-700 w-30px h-30px'"
    [attr.aria-label]="bellCount ? bellCount + ' notifications need your attention' : 'Notifications'">
    <i class="bi bi-bell-fill" [ngClass]="variant === 'header' ? 'fs-1 header-icons-font-size' : 'fs-2'"></i>
    <span class="notification-bell__badge">
      <app-count-badge [count]="bellCount" type="action" label="notifications need your attention"></app-count-badge>
    </span>
  </button>

  <div ngbDropdownMenu class="notification-bell__panel p-0" [class.notification-bell__panel--sidebar]="variant === 'sidebar'" role="dialog" aria-label="Notifications">
    <div class="d-flex align-items-center justify-content-between px-4 pt-4 pb-2">
      <h4 #panelHeading tabindex="-1" class="m-0 fw-bolder text-gray-800 notification-bell__heading">Notifications</h4>
      <button type="button" class="btn btn-link btn-sm p-0" (click)="markAllRead()" [disabled]="markingAll">Mark all as read</button>
    </div>

    <!-- SAN-1461 (WCAG 4.1.2) — tablist with roving tabindex and arrow keys. -->
    <div class="notification-bell__tabs" role="tablist" aria-label="Notification filter"
      (keydown.arrowright)="switchTab($event)" (keydown.arrowleft)="switchTab($event)">
      <button #tabAll type="button" role="tab" id="nb-tab-all" aria-controls="nb-panel" class="notification-bell__tab"
        [class.notification-bell__tab--active]="tab === 'all'" [attr.aria-selected]="tab === 'all'"
        [attr.tabindex]="tab === 'all' ? 0 : -1" (click)="tab = 'all'">
        All
        <span class="notification-bell__tab-count" *ngIf="unreadCount"><span aria-hidden="true">{{ unreadCount }}</span><span class="visually-hidden">, {{ unreadCount }} new</span></span>
      </button>
      <button #tabAction type="button" role="tab" id="nb-tab-action" aria-controls="nb-panel" class="notification-bell__tab"
        [class.notification-bell__tab--active]="tab === 'action'" [attr.aria-selected]="tab === 'action'"
        [attr.tabindex]="tab === 'action' ? 0 : -1" (click)="tab = 'action'">
        Needs action
        <span class="notification-bell__tab-count" *ngIf="actionCount"><span aria-hidden="true">{{ actionCount }}</span><span class="visually-hidden">, {{ actionCount }} need action</span></span>
      </button>
    </div>

    <div class="notification-bell__list" role="tabpanel" id="nb-panel" [attr.aria-labelledby]="'nb-tab-' + tab">
      <div *ngIf="loading && !loaded" class="px-4 py-6 text-center notification-bell__muted fs-7">Loading…</div>

      <div *ngIf="loaded && !visibleItems.length" class="px-4 py-6 text-center notification-bell__muted fs-7">
        {{ tab === 'action' ? 'Nothing needs your action right now.' : 'No notifications yet.' }}
      </div>

      <ng-container *ngIf="todayItems.length">
        <div class="notification-bell__group">Today</div>
        <ng-container *ngFor="let item of todayItems; trackBy: trackByUuid">
          <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="earlierItems.length">
        <div class="notification-bell__group">Earlier</div>
        <ng-container *ngFor="let item of earlierItems; trackBy: trackByUuid">
          <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div class="notification-bell__footer px-4 py-3">
      <span class="notification-bell__muted fs-8">Items that need your action stay here until you act. History kept for 90 days.</span>
      <button type="button" class="btn btn-link btn-sm p-0 fs-7" (click)="viewAll()">View all</button>
    </div>
  </div>
</div>

<ng-template #itemTemplate let-item>
  <!-- SAN-1461 — Enter and Space open the row; the inner buttons stop both
       keys, so Accept / Decline never also open the row. -->
  <div class="notification-bell__item" [class.notification-bell__item--unread]="!item.isRead" role="button" tabindex="0"
    (click)="open(item)" (keydown.enter)="open(item)" (keydown.space)="$event.preventDefault(); open(item)">
    <span class="notification-bell__dot" aria-hidden="true"
      [ngClass]="item.isRead ? '' : (item.isActionRequired ? 'notification-bell__dot--action' : 'notification-bell__dot--new')"></span>
    <div class="flex-grow-1 min-w-0">
      <div class="fs-7 fw-bold text-gray-800">
        <span class="visually-hidden">{{ readStateLabel(item) }}</span>
        <i *ngIf="statusIcon(item) as icon" class="bi {{ icon }} fs-7 text-gray-600 me-1" aria-hidden="true"></i>{{ item.title }}
      </div>
      <div class="fs-8 notification-bell__muted text-truncate-2">{{ item.message }}</div>
      <div class="fs-9 notification-bell__muted mt-1">{{ item.createdAt | date: 'medium' }}</div>
      <div class="d-flex gap-2 mt-2" *ngIf="isPendingRequest(item)">
        <button type="button" class="btn btn-primary btn-sm py-1 px-3" [disabled]="acting[item.uuid]"
          [attr.aria-label]="'Accept connection request: ' + item.title"
          (click)="respond(item, true, $event)" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">Accept</button>
        <button type="button" class="btn btn-light btn-sm py-1 px-3" [disabled]="acting[item.uuid]"
          [attr.aria-label]="'Decline connection request: ' + item.title"
          (click)="respond(item, false, $event)" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">Decline</button>
      </div>
      <div class="d-flex gap-2 mt-2" *ngIf="hasCta(item)">
        <button type="button" class="btn btn-primary btn-sm py-1 px-3" (click)="openCta(item, $event)" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">{{ item.cta.label }}</button>
      </div>
    </div>
  </div>
</ng-template>
